<!-- version 2021/05/20 -->
<template>
    <button class="input-group-addon"></button>
</template>

<script>
    export default {
    }
</script>

<style lang="sass" scoped>
    @mixin arrow-before-position($color:rgba(0, 0, 0, 0.24), $rotate:45deg, $margin-top:0, $right:18px)
        position: relative
        display: inline-block
        &::before
            content: ''
            width: 10px
            height: 10px
            border: 0px
            border-top: solid 2px $color
            border-right: solid 2px $color
            -ms-transform: rotate($rotate)
            -webkit-transform: rotate($rotate)
            transform: rotate($rotate)
            position: absolute
            top: 50%
            right: $right
            margin-top: $margin-top
    @mixin arrow-after-position($color:rgba(0, 0, 0, 0.24), $rotate:45deg, $margin-top:0, $right:18px)
        position: relative
        display: inline-block
        &::after
            content: ''
            width: 10px
            height: 10px
            border: 0px
            border-top: solid 2px $color
            border-right: solid 2px $color
            -ms-transform: rotate($rotate)
            -webkit-transform: rotate($rotate)
            transform: rotate($rotate)
            position: absolute
            top: 50%
            right: $right
            margin-top: $margin-top

    button
        min-height: 38px
        background-color: #FFFFFF
        border: none
        @include arrow-before-position(#28c3cd, 315deg, 4px, 7px)
        @include arrow-after-position(#28c3cd, 135deg, -7px, 7px)

</style>